import React from 'react';
import IconSelector from '../common/IconSelector';
import PriorityBadge from '../common/PriorityBadge';

const AgendaItemsList = ({ items, triggers }) => {
  return (
    <div className="space-y-3 mb-4">
      {items.map((item, index) => (
        <div key={index} className="border rounded-md p-3">
          <div className="flex justify-between items-center mb-1">
            <div className="flex items-center">
              <span className="text-sm font-medium">{item.title}</span>
              <span className="ml-2">
                <PriorityBadge priority={item.priority} />
              </span>
            </div>
            <span className="text-xs text-gray-500">{item.duration}</span>
          </div>
          <p className="text-xs text-gray-600 mb-2">{item.description}</p>
          {item.relatedTriggers.length > 0 && (
            <div className="flex items-center text-xs">
              <span className="text-gray-500 mr-1">Related triggers:</span>
              <div className="flex gap-1">
                {item.relatedTriggers.map((triggerId, idx) => {
                  const trigger = triggers.find(t => t.id === triggerId);
                  return trigger ? (
                    <span key={idx} className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                      <IconSelector type={trigger.type} />
                      <span className="ml-1">{trigger.title.substring(0, 20)}{trigger.title.length > 20 ? '...' : ''}</span>
                    </span>
                  ) : null;
                })}
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default AgendaItemsList;